module.exports = __webpack_public_path__ + "img/icon_arrow_r_orange.42845c6f.svg";